export default __webpack_public_path__ + "static/media/three.8c91ad90.png";